// extracted by mini-css-extract-plugin
export default {"AdSlotOffsite":"bgl_a bhk_bi"};